interface AppError extends Error {
    status?: number
}

export const createError = (message: string, status: number): AppError => {
    const error: AppError = new Error(message)
    error.status = status
    return error
}
